export enum CookieConsentType {
  STRICTLY_NECESSARY = 'C0001',
  PERFORMANCE = 'C0002',
  FUNCTIONAL = 'C0003',
  TARGETING = 'C0004',
  SHARE_OR_SALE_OF_PERSONAL_DATA = 'SSPD_BG',
  SALE_OF_PERSONAL_DATA = 'SPD_BG',
}

export type CookieConsentState = Record<keyof typeof CookieConsentType, boolean>;

export type CookieConsentCallback = (consentState: CookieConsentState) => void;
